import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    {
      alert('Site não funcional. Em desenvolvimento.')
    }
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
